import { Composer } from 'vue-i18n';

import { translateError } from './base';

export interface UseLoginErrorTranslation {
  translateError: (error: Error | null) => string;
}

export function useLoginErrorTranslation(i18n: Composer): UseLoginErrorTranslation {
  const { t } = i18n;

  function translateLoginError(error: Error | null): string {
    if (!error) return '';

    const { code } = error as Dictionary;
    if (!code) return translateError(i18n, error);

    if (code.includes('network error')) {
      return t('Login.error.networkError').toString();
    }
    if (['auth/too-many-requests)'].includes(code)) {
      return t('Login.error.tooManyRequests').toString();
    }

    if (['auth/wrong-password', 'auth/user-not-found'].includes(code)) {
      return t('Login.error.wrongCredentials').toString();
    }
    return translateError(i18n, error);
  }

  return {
    translateError: translateLoginError,
  };
}
